'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var agui = require('arm-gui/dist/controls');
var armCommon = require('arm-common');
var update = require('immutability-helper');
var p = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);
var p__default = /*#__PURE__*/_interopDefaultLegacy(p);

var name = "arm-file-uploader";
var version = "2.1.0";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "./dist/main/index.js";
var files = [
	"dist",
	"index.js",
	"README.md"
];
var devDependencies = {
	"arm-core-layouts": "^0.1.1",
	"arm-common": "1.0.4",
	"arm-gui": "4.0.0",
	"arm-gulp-builders": "1.2.0",
	"arm-themes": "^1.2.0",
	"arm-visual-component": "^2.0.3",
	gulp: "^4.0.2",
	react: "^16.13.1",
	"react-dom": "^16.13.1",
	"react-redux": "^7.2.0",
	"react-router-dom": "^5.2.0",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var peerDependencies = {
	"arm-common": ">=1.0.0",
	"arm-gui": ">=3.1.0 <5.0.0-0"
};
var dependencies = {
	"immutability-helper": "3.1.1",
	"prop-types": "15.7.2"
};
var scripts = {
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish --tag beta",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish"
};
var publishConfig = {
	registry: "https://nexus.armundia.com/repository/npm-releases"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var InputFileActions = /*#__PURE__*/function () {
  function InputFileActions(file, chunkSize) {
    _classCallCheck(this, InputFileActions);

    this.name = file.name;
    this.size = file.size;
    this.chunkSize = chunkSize;
    this.file = file;
    this.percentage = 0;
    this.start = 0;
    this.end = chunkSize;
    this.fileEnded = false;
    this.startUpload = false;
    this.uploadURL = 'URL not set';
  }

  _createClass(InputFileActions, [{
    key: "slice",
    value: function slice(file) {
      this.startUpload = true;
      var blob = file.slice(this.start, this.end);
      return blob;
    }
  }, {
    key: "uploadBlob",
    value: function uploadBlob(blob, callBack) {
      var url = this.uploadURL + this.name;
      return $.ajax({
        url: url,
        data: blob,
        cache: false,
        processData: false,
        dataType: 'json',
        contentType: 'application/octet-stream',
        type: "POST",
        success: function success(data) {
          return callBack(data);
        },
        error: function error() {
          console.error('ERROR HERE !!!');
          return null;
        }
      });
    }
  }, {
    key: "checkFileEnd",
    value: function checkFileEnd(data) {
      var result = {};

      if (this.fileEnded) {
        result.end = true;
        this.startUpload = false;
        return result;
      }

      this.start = this.end;
      this.end = armCommon.ArmDecimal.add(this.end, this.chunkSize);

      if (this.end >= this.size) {
        this.end = this.size;
        this.fileEnded = true;
      }

      if (this.name !== data.id) {
        this.name = data.id;
      }

      var percentage = armCommon.ArmDecimal.div(this.end, this.size);
      percentage = armCommon.ArmDecimal.mul(percentage, 100);
      result.percentage = armCommon.ArmDecimal.round(percentage, 0);
      result.newBlob = this.slice(this.file);
      return result;
    }
  }]);

  return InputFileActions;
}();

var InputFile = /*#__PURE__*/function (_Component) {
  _inherits(InputFile, _Component);

  var _super = _createSuper(InputFile);

  function InputFile(props) {
    var _this;

    _classCallCheck(this, InputFile);

    _this = _super.call(this, props);
    /**
     * Funzionalita del componente
     */

    _this.checkFileEnd = _this.checkFileEnd.bind(_assertThisInitialized(_this));
    _this.startUpload = _this.startUpload.bind(_assertThisInitialized(_this));
    _this.onClear = _this.onClear.bind(_assertThisInitialized(_this));
    _this.ondragover = _this.ondragover.bind(_assertThisInitialized(_this));
    _this.ondragleave = _this.ondragleave.bind(_assertThisInitialized(_this));
    _this.onOpenDetails = _this.onOpenDetails.bind(_assertThisInitialized(_this));
    _this.transformBytes = _this.transformBytes.bind(_assertThisInitialized(_this));
    var chunkSize = _this.props.chunkSize || '1000000';
    _this.state = {
      language: _this.props.language || 'it',
      inputFileUploader: {},
      percentage: 0,
      chunkSize: chunkSize,
      inputValue: '',
      fileSize: '0 KB',
      onDragClass: '',
      detailsOpen: false
    };
    return _this;
  }

  _createClass(InputFile, [{
    key: "importFile",
    value: function importFile(e) {
      var file = e.target.files[0];
      console.log(file);

      if (file) {
        var inputFileUploader = new InputFileActions(file, this.state.chunkSize);
        inputFileUploader.uploadURL = this.props.uploadURL + "upload/file/"; // let fileSize = ArmDecimal.div(file.size, 1048576);
        // fileSize = ArmDecimal.round(fileSize, 2);

        var newState = update__default['default'](this.state, {
          inputFileUploader: {
            $set: inputFileUploader
          },
          percentage: {
            $set: 0
          },
          fileSize: {
            $set: this.transformBytes(file.size)
          },
          detailsOpen: {
            $set: true
          }
        });
        this.setState(newState);
      }
    }
  }, {
    key: "startUpload",
    value: function startUpload() {
      /**
       * Se serve prendere il momento in qui il upload del file inizia
       */
      if (this.props.onStartUpload) {
        this.props.onStartUpload(this.state.inputFileUploader.file);
      }

      var startBlob = this.state.inputFileUploader.slice(this.state.inputFileUploader.file);
      this.uploadBlob(startBlob);
    }
  }, {
    key: "uploadBlob",
    value: function uploadBlob(blob) {
      this.state.inputFileUploader.uploadBlob(blob, this.checkFileEnd);
    }
  }, {
    key: "checkFileEnd",
    value: function checkFileEnd(data) {
      var _this2 = this;

      var result = this.state.inputFileUploader.checkFileEnd(data);

      if (!result.end && result.newBlob) {
        var newState = update__default['default'](this.state, {
          percentage: {
            $set: result.percentage
          }
        });
        this.setState(newState, function () {
          return _this2.uploadBlob(result.newBlob);
        });
      } else if (result.end) {
        var file = this.state.inputFileUploader.file;
        var id = this.state.inputFileUploader.name;

        if (this.props.clearOnUpload) {
          this.onClear();
        }
        /**
         * Funzione di ritorno per il risultato del upload
         * Contiene il file con il nome, dimensioni, etc...
         * Piu il ID del file che serve per riprendere il file dal backend
         */


        this.props.onFileUpload(file, id);
      }
    }
  }, {
    key: "onClear",
    value: function onClear() {
      var newState = update__default['default'](this.state, {
        inputValue: {
          $set: ''
        },
        inputFileUploader: {
          $set: {}
        },
        percentage: {
          $set: 0
        },
        detailsOpen: {
          $set: false
        },
        fileSize: {
          $set: '0 KB'
        }
      });
      this.setState(newState);
    }
  }, {
    key: "ondragover",
    value: function ondragover(e) {
      var newState = update__default['default'](this.state, {
        onDragClass: {
          $set: 'onDrag'
        }
      });
      this.setState(newState);
    }
  }, {
    key: "ondragleave",
    value: function ondragleave(e) {
      var newState = update__default['default'](this.state, {
        onDragClass: {
          $set: ''
        }
      });
      this.setState(newState);
    }
  }, {
    key: "onOpenDetails",
    value: function onOpenDetails() {
      var newState = update__default['default'](this.state, {
        detailsOpen: {
          $set: !this.state.detailsOpen
        }
      });
      this.setState(newState);
    }
  }, {
    key: "transformBytes",
    value: function transformBytes(size) {
      var ret = '';
      var fileSizeKB = armCommon.ArmDecimal.div(size, 1024);
      var fileSize = size;
      var timesDivided = 0;

      while (armCommon.ArmDecimal.div(fileSize, 1024) > 1) {
        fileSize = armCommon.ArmDecimal.div(fileSize, 1024);
        timesDivided++;
      }

      ret = armCommon.ArmDecimal.round(fileSize, 2);

      if (timesDivided === 0) {
        ret = ret + ' Bytes';
      } else if (timesDivided === 1) {
        ret = ret + ' KB';
      } else if (timesDivided === 2) {
        ret = ret + ' MB';
      } else if (timesDivided === 3) {
        ret = ret + ' GB';
      }

      ret = ret + ' (' + armCommon.ArmDecimal.round(fileSizeKB, 2) + ' KB)';
      return ret;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var visible = '';

      if (this.state.inputFileUploader && !this.state.inputFileUploader.fileEnded && this.state.percentage !== 0 && this.state.percentage !== 100) {
        visible = 'opacity100';
      }

      var disabled = this.props.disabled || false;

      if (this.state.inputFileUploader.fileEnded === false && this.state.percentage !== 0 && this.state.percentage !== 100) {
        disabled = true;
      } // let iconUp = this.props.iconUp || 'fas fa-caret-up fa-lg';
      // let iconDown = this.props.iconDown || 'fas fa-caret-down fa-lg';


      var iconUp = this.props.iconUp || '';
      var iconDown = this.props.iconDown || '';
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: 'outerInput ' + this.state.onDragClass + ' ' + this.props.className
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          width: '95%'
        }
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "inputFile",
        onDragOver: this.ondragover,
        onDragLeave: this.ondragleave,
        onDrop: this.ondragleave
      }, /*#__PURE__*/React__default['default'].createElement("input", {
        type: "file",
        value: this.state.inputValue,
        onChange: function onChange(e) {
          return _this3.importFile(e);
        },
        title: this.props.title || '',
        disabled: disabled
      }), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "inputBrowse"
      }, !this.props.compact && /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
        small: true,
        onClick: this.onClickBrowse,
        disabled: disabled
      }, armCommon.i18n('AFU.LABEL_BROWSE', 'Browse ...')), /*#__PURE__*/React__default['default'].createElement("span", null, armCommon.i18n('AFU.LABEL_DROP_FILES', 'Or Drop files here'))), this.state.inputFileUploader.startUpload ? /*#__PURE__*/React__default['default'].createElement(agui.ProgressBar, {
        className: 'inputFileProgressBar ' + visible,
        width: this.state.percentage,
        height: "5px",
        animateBar: true,
        showPercentage: false
      }) : null)), /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          display: 'flex',
          cursor: 'pointer'
        },
        onClick: this.onOpenDetails
      }, this.state.detailsOpen ? /*#__PURE__*/React__default['default'].createElement("i", {
        className: iconUp ? iconUp : "iconUp"
      }) : /*#__PURE__*/React__default['default'].createElement("i", {
        className: iconDown ? iconDown : "iconDown"
      }))), this.state.detailsOpen && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "drop"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "info"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "fileInfo"
      }, this.state.inputFileUploader.file ? this.state.inputFileUploader.file.name : armCommon.i18n('AFU.LABEL_NO_DETAILS', 'Nessun file selezionato'), /*#__PURE__*/React__default['default'].createElement("br", null), this.state.fileSize, /*#__PURE__*/React__default['default'].createElement("br", null), this.state.inputFileUploader.fileEnded === false && this.state.percentage === 0 ? /*#__PURE__*/React__default['default'].createElement("span", null, armCommon.i18n('AFU.LABEL_CODE_TEST', 'Ready to upload'), " ") : this.state.inputFileUploader.fileEnded === false && this.state.percentage !== 0 && this.state.percentage !== 100 ? /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React__default['default'].createElement("span", null, armCommon.i18n('AFU.LABEL_UPLOADING', 'Uploading...')), /*#__PURE__*/React__default['default'].createElement("span", {
        style: {
          marginLeft: "auto"
        }
      }, this.state.percentage, " %"))) : this.state.inputFileUploader.fileEnded === true && this.state.percentage === 100 ? /*#__PURE__*/React__default['default'].createElement("span", null, armCommon.i18n('AFU.LABEL_FILE_UPLOADED', 'File uploaded')) : null), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "fileButton"
      }, /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
        onClick: this.onClear,
        small: true
      }, " ", armCommon.i18n('AFU.BUTTON_CLEAR', 'Clear')), /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
        bs: "primary",
        onClick: this.startUpload,
        small: true
      }, armCommon.i18n('AFU.BUTTON_UPLOAD', 'Upload'))))));
    }
  }]);

  return InputFile;
}(React.Component);

var ImgDrop = (function () {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "5.25rem",
    height: "3.25rem",
    viewBox: "0 0 75 51",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "0.50000024",
    y1: "1.0000005",
    x2: "0.4999998",
    y2: "-1.7264891E-07",
    id: "gradient_1"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0",
    stopColor: "#4CCBAB"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0.55868685",
    stopColor: "#47ADB4"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0.8310878",
    stopColor: "#4291BD"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "1",
    stopColor: "#3E75C8"
  }))), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15.4736 0.062217L15.4736 0L58.4726 0L58.4726 0.0111348L74.0192 10.897L69.909 16.767L56.1981 7.1665L17.8211 7.1665L4.11022 16.767L0 10.897L15.4736 0.062217ZM29.7235 32.2822L22.4736 32.2822L36.9733 10.7827L51.473 32.2822L44.2231 32.2822L44.2231 50.1985L29.7235 50.1985L29.7235 32.2822Z",
    transform: "matrix(-1 -8.742278E-08 8.742278E-08 -1 74.01929 50.198242)",
    id: "Shape",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }));
});

/**
 * @callback _ButtonFile
 * @param {ButtonFileProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} ButtonFileProps ButtonFileProps properties
 * @prop {string} uploadURL base path of url that will concat with "upload/file/"
 * ```js
 * const url = uploadURL + "upload/file/"
 * ```
 * @prop {number} [chunkSize=1000000] blob size to send to back end (default 1MB)
 * @prop {(file: File) => any} [onStartUpload] function when start uploading
 * @prop {(file: File, name: string) => any} [onFileUpload] function on end of upload
 * @prop {boolean} [clearOnUpload] clear file state on end of upload
 * @prop {boolean} [closeOnUpload] close the dialog on end of upload
 * @prop {boolean} [disabled] disable the button
 * @prop {boolean} [closeOnBlur] close the dialog when click outside of it
 * @prop {string} [className] component selector
 * @prop {string} [iconBtn] css class glyph button
 * @prop {string} [labelBtn] label of button
 * @prop {('right'|'left')} [position='left'] dialog position
 * @prop {string} [iconClear] css class glyph dialog clear button
 * @prop {string} [iconUpload] css class glyph dialog upload button
 */
exports.typedefs = {};

function transformBytes(size) {
  var fileSizeKB = armCommon.ArmDecimal.div(size, 1024);
  var fileSize = size;
  var timesDivided = 0;

  while (armCommon.ArmDecimal.div(fileSize, 1024) > 1) {
    fileSize = armCommon.ArmDecimal.div(fileSize, 1024);
    timesDivided++;
  }

  var kb = "(".concat(armCommon.ArmDecimal.round(fileSizeKB, 2), " KB)");
  var ret = armCommon.ArmDecimal.round(fileSize, 2);

  switch (timesDivided) {
    case 0:
      return "".concat(ret, " Bytes ").concat(kb);

    case 1:
      return "".concat(ret, " KB ").concat(kb);

    case 2:
      return "".concat(ret, " MB ").concat(kb);

    case 3:
      return "".concat(ret, " GB ").concat(kb);
  }
}

function getIcon(fileName) {
  if (!fileName) return null;
  var extension = fileName.split('.').pop().toLowerCase();

  var concatBaseIcon = function concatBaseIcon(ext, color) {
    return /*#__PURE__*/React__default['default'].createElement("i", {
      style: {
        color: color
      },
      className: "".concat(classNameComponent, "-icon-file far fa-file-").concat(ext)
    });
  };

  switch (extension) {
    case 'pdf':
      return concatBaseIcon('pdf', '#ad0b00');

    case 'xls':
    case 'xlsx':
      return concatBaseIcon('excel', '#02633b');

    case 'doc':
    case 'docx':
      return concatBaseIcon('word', '#005197');

    case 'ppt':
    case 'pptx':
      return concatBaseIcon('powerpoint', '#ba371b');

    case 'zip':
    case 'rar':
    case '7z':
      return concatBaseIcon('archive', '#f7e196');

    case 'csv':
      return concatBaseIcon('csv', '#02633b');

    default:
      return /*#__PURE__*/React__default['default'].createElement("i", {
        className: "".concat(classNameComponent, "-icon-file far fa-file")
      });
  }
}

var classNameComponent = 'arm-file-uploader-button-file';
/**
 * Button that opens a dialog with input file
 * @type {_ButtonFile}
 */

function ButtonFile(props) {
  var _inputFileUploader$fi;

  var _props$chunkSize = props.chunkSize,
      chunkSize = _props$chunkSize === void 0 ? 1000000 : _props$chunkSize,
      uploadURL = props.uploadURL,
      onStartUpload = props.onStartUpload,
      onFileUpload = props.onFileUpload,
      clearOnUpload = props.clearOnUpload,
      closeOnUpload = props.closeOnUpload,
      closeOnBlur = props.closeOnBlur,
      disabled = props.disabled,
      className = props.className,
      iconBtn = props.iconBtn,
      labelBtn = props.labelBtn,
      _props$position = props.position,
      position = _props$position === void 0 ? 'left' : _props$position,
      iconClear = props.iconClear,
      iconUpload = props.iconUpload;

  var _useState = React.useState({
    inputFileUploader: {},
    percentage: 0,
    inputValue: '',
    fileSize: '0 KB',
    onDragClass: '',
    detailsOpen: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onDragClass = state.onDragClass,
      inputFileUploader = state.inputFileUploader,
      percentage = state.percentage,
      detailsOpen = state.detailsOpen,
      fileSize = state.fileSize,
      inputValue = state.inputValue;
  var ref = React.useRef();

  var onClear = function onClear() {
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      inputFileUploader: {},
      percentage: 0,
      inputValue: '',
      fileSize: '0 KB'
    }));
  };

  var closeDetails = function closeDetails(e) {
    if (ref !== null && ref !== void 0 && ref.current && !ref.current.contains(e.target)) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        detailsOpen: false
      }));
    }
  };

  var onOpenDetails = function onOpenDetails(bool) {
    if (bool === undefined) bool = !detailsOpen;
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      detailsOpen: bool
    }));
  };

  React.useEffect(function () {
    if (closeOnBlur && detailsOpen && (percentage === 0 || percentage === 100)) document.addEventListener('mousedown', closeDetails);else if (closeOnBlur) document.removeEventListener('mousedown', closeDetails);
    return function () {
      return closeOnBlur && document.removeEventListener('mousedown', closeDetails);
    };
  }, [closeOnBlur, detailsOpen, percentage]);

  var importFile = function importFile(e) {
    e.preventDefault();
    e.stopPropagation();
    var file = e.target.files[0];
    console.debug('[ButtonFile]: import file', file);

    if (file) {
      var _inputFileUploader = new InputFileActions(file, chunkSize);

      _inputFileUploader.uploadURL = uploadURL + "upload/file/";
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        inputFileUploader: _inputFileUploader,
        percentage: 0,
        fileSize: transformBytes(file.size),
        detailsOpen: true
      }));
    }
  };

  var checkFileEnd = function checkFileEnd(data) {
    var result = inputFileUploader.checkFileEnd(data);

    if (!result.end && result.newBlob) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        percentage: result.percentage
      }));
      uploadBlob(result.newBlob);
    } else if (result.end) {
      var file = inputFileUploader.file;
      var id = inputFileUploader.name;
      if (clearOnUpload) onClear();
      if (closeOnUpload) onOpenDetails(false);
      /**
       * Funzione di ritorno per il risultato del upload
       * Contiene il file con il nome, dimensioni, etc...
       * Piu il ID del file che serve per riprendere il file dal backend
       */

      if (onFileUpload) onFileUpload(file, id);
    }
  };

  var uploadBlob = function uploadBlob(blob) {
    inputFileUploader.uploadBlob(blob, checkFileEnd);
  };

  var startUpload = function startUpload() {
    if (onStartUpload) onStartUpload(inputFileUploader.file);
    var startBlob = inputFileUploader.slice(inputFileUploader.file);
    uploadBlob(startBlob);
  };

  var onDragOver = function onDragOver() {
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      onDragClass: "".concat(classNameComponent, "-ondrag")
    }));
  };

  var onDragLeave = function onDragLeave() {
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      onDragClass: ''
    }));
  };

  var inProgress = function inProgress() {
    return inputFileUploader && inputFileUploader.fileEnded === false && percentage !== 0 && percentage !== 100;
  };

  var dis = !!disabled || inProgress();
  var fileName = inputFileUploader === null || inputFileUploader === void 0 ? void 0 : (_inputFileUploader$fi = inputFileUploader.file) === null || _inputFileUploader$fi === void 0 ? void 0 : _inputFileUploader$fi.name;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: ref,
    className: "".concat(classNameComponent, " ").concat(className || '').trimEnd()
  }, /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
    icon: iconBtn || 'fas fa-upload',
    onClick: function onClick() {
      return onOpenDetails();
    },
    disabled: dis
  }, labelBtn || armCommon.i18n('AFU.BTN_LABEL', 'Import File')), detailsOpen && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-drop-").concat(position)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-container"),
    onDragOver: onDragOver,
    onDragLeave: onDragLeave,
    onDrop: onDragLeave
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-context ").concat(onDragClass)
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    className: "".concat(classNameComponent, "-input"),
    type: "file",
    title: "",
    value: inputValue,
    onChange: function onChange(e) {
      return importFile(e);
    },
    disabled: dis
  }), getIcon(fileName) || /*#__PURE__*/React__default['default'].createElement(ImgDrop, null), fileName ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-info")
  }, /*#__PURE__*/React__default['default'].createElement("b", null, inputFileUploader.file.name), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("small", null, /*#__PURE__*/React__default['default'].createElement("i", null, fileSize))) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-no-file")
  }, /*#__PURE__*/React__default['default'].createElement("small", {
    style: {
      lineHeight: 3
    }
  }, armCommon.i18n('AFU.DRAG_FILE', 'Drag a file here'), /*#__PURE__*/React__default['default'].createElement("br", null), armCommon.i18n('AFU.OR', 'or'), /*#__PURE__*/React__default['default'].createElement("br", null)), /*#__PURE__*/React__default['default'].createElement("b", null, armCommon.i18n('AFU.SELECT_FILE', 'Select a file')))), inputFileUploader.fileEnded !== undefined && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-progress")
  }, percentage !== 0 && percentage !== 100 && /*#__PURE__*/React__default['default'].createElement(agui.ProgressBar, {
    animateBar: true,
    showPercentage: true,
    height: "1rem",
    width: percentage
  }), percentage === 100 && armCommon.i18n('AFU.LABEL_FILE_UPLOADED', 'File uploaded'))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-actions")
  }, /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
    icon: iconClear,
    disabled: dis,
    onClick: onClear,
    bs: "secondary"
  }, " ", armCommon.i18n('AFU.BUTTON_CLEAR', 'Clear')), /*#__PURE__*/React__default['default'].createElement(agui.aButton, {
    icon: iconUpload,
    disabled: Object.keys(inputFileUploader).length === 0 || disabled,
    onClick: startUpload
  }, armCommon.i18n('AFU.BUTTON_UPLOAD', 'Upload')))));
}

ButtonFile.propType = {
  //logic
  uploadURL: p__default['default'].string.isRequired,
  chunkSize: p__default['default'].number,
  onStartUpload: p__default['default'].func,
  clearOnUpload: p__default['default'].bool,
  closeOnUpload: p__default['default'].bool,
  onFileUpload: p__default['default'].func,
  //visual 
  disabled: p__default['default'].bool,
  closeOnBlur: p__default['default'].bool,
  className: p__default['default'].string,
  iconBtn: p__default['default'].string,
  labelBtn: p__default['default'].string,
  position: p__default['default'].oneOf(['right', 'left']),
  iconClear: p__default['default'].string,
  iconUpload: p__default['default'].string
};

var index = {
  version: pckg.version,
  ButtonFile: ButtonFile,
  InputFile: InputFile
};

exports.ButtonFile = ButtonFile;
exports.InputFile = InputFile;
exports.default = index;
//# sourceMappingURL=index.js.map
